import { Text } from "preact-i18n";
import { useState, useContext } from "preact/hooks";

import { Configs } from "../../helpers/context";
import { getOrderTotal } from "../../helpers/order";
import { formatIntegerCurrencyString } from "../../helpers/formatters";

import ConfirmationModal from "../shared/ConfirmationModal";

import "../../style/EstimatedSurcharge.css";

const EstimatedSurcharge = ({
  payLink,
  order,
}) => {
  const configsContext = useContext(Configs);
  const localeLanguage = configsContext?.configs?.ecommerceLocaleLanguage;

  const [isConfirmationModalOpen, setConfirmationModalOpen] = useState(false);

  const orderAmount = Number(getOrderTotal(order) || 0);
  const surchargeAmount = Math.ceil(orderAmount * 0.03);

  const surchargeAmountString = formatIntegerCurrencyString(
    surchargeAmount,
    payLink.currency,
    localeLanguage,
  );

  return (
    <div className="estimated-surcharge">
      <svg className="estimated-surcharge-icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="40" height="40" viewBox="0 0 40 40">
        <g fill="currentColor">
          <path d="m20.5 3.76245c-3.2139 0-6.3557.95305-9.028 2.73862-2.67231 1.78557-4.75511 4.32343-5.98504 7.29273-1.22992 2.9693-1.55172 6.2367-.92471 9.3889s2.17467 6.0476 4.44727 8.3202c2.27258 2.2726 5.16808 3.8203 8.32028 4.4473s6.4195.3052 9.3888-.9247 5.5072-3.3127 7.2928-5.985 2.7386-5.8141 2.7386-9.028c-.005-4.3083-1.7186-8.4386-4.765-11.48504-3.0464-3.04639-7.1767-4.76003-11.485-4.76501zm0 30.00005c-2.7195 0-5.3779-.8065-7.6391-2.3173-2.2612-1.5109-4.02353-3.6584-5.06424-6.1709-1.0407-2.5124-1.313-5.2771-.78245-7.9443.53055-2.6673 1.84011-5.1173 3.76309-7.0403 1.923-1.92294 4.373-3.2325 7.0402-3.76305 2.6673-.53054 5.4319-.25825 7.9444.78246 2.5125 1.0407 4.6599 2.80309 6.1708 5.06429 1.5109 2.2611 2.3173 4.9196 2.3173 7.6391-.0042 3.6454-1.4543 7.1403-4.032 9.718s-6.0726 4.0277-9.718 4.032z"/>
          <path d="m20.5 18.7625c-.3315 0-.6494.1318-.8838.3662s-.3661.5523-.3662.8838v8.3333c0 .3315.1317.6494.3661.8839.2344.2344.5524.3661.8839.3661s.6495-.1317.8839-.3661c.2344-.2345.3661-.5524.3661-.8839v-8.3333c-.0001-.3315-.1318-.6494-.3662-.8838s-.5523-.3662-.8838-.3662z"/>
          <path d="m20.4951 11.8875c-.4971.0014-.9733.2001-1.3239.5524-.3507.3524-.5471.8295-.5462 1.3266.0008.3707.1115.7328.318 1.0406s.4996.5475.8423.6888.7195.1778 1.083.105c.3634-.0728.6971-.2517.959-.5141.2618-.2623.44-.5964.512-.96s.0346-.7404-.1074-1.0828-.3824-.635-.6906-.8408c-.3083-.2059-.6706-.3157-1.0413-.3157z"/>
        </g>
      </svg>
      {orderAmount > 0 ? (
        <p className="estimated-surcharge-text">
          <Text id="ESTIMATED_SURCHARGE_TEXT_WITH_AMOUNT" fields={{ amount: surchargeAmountString }}>
            *A credit surcharge fee of up to 3% may apply (up to {surchargeAmountString}).
          </Text>
          {' '}
          <span className="estimated-surcharge-text-link" onClick={() => setConfirmationModalOpen(true)}>
            <Text id="ESTIMATED_SURCHARGE_LINK">
              Learn more
            </Text>
          </span>
        </p>
      ) : (
        <p className="estimated-surcharge-text">
          <Text id="ESTIMATED_SURCHARGE_TEXT">
            *A credit surcharge fee of up to 3% may apply.
          </Text>
          <div>
            <span className="estimated-surcharge-text-link" onClick={() => setConfirmationModalOpen(true)}>
              <Text id="ESTIMATED_SURCHARGE_LINK">
                Learn more
              </Text>
            </span>
          </div>
        </p>
      )}

      <ConfirmationModal
        isOpen={isConfirmationModalOpen}
        onCancel={() => setConfirmationModalOpen(false)}
        onConfirm={() => setConfirmationModalOpen(false)}
        titleText={<Text id="ESTIMATED_SURCHARGE_MODAL_TITLE">What is Credit Surcharge?</Text>}
        confirmText={<Text id="ESTIMATED_SURCHARGE_MODAL_CONFIRM">Okay</Text>}
      >
        <p>
          <Text id="ESTIMATED_SURCHARGE_MODAL_DESCRIPTION">
            A credit surcharge is a fee of up to 3% that customers pay when using a credit card.
            Any applicable surcharge will not be reflected in the total but will only be added during payment.
          </Text>
        </p>
      </ConfirmationModal>
    </div>
  );
};

export default EstimatedSurcharge;
